import { render, staticRenderFns } from "./ReadingListCard.vue?vue&type=template&id=29e94a1e&scoped=true&"
import script from "./ReadingListCard.vue?vue&type=script&lang=js&"
export * from "./ReadingListCard.vue?vue&type=script&lang=js&"
import style0 from "./ReadingListCard.vue?vue&type=style&index=0&id=29e94a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e94a1e",
  null
  
)

export default component.exports